export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL
export const BASE_API_URL_LOCAL = process.env.REACT_APP_BASE_API_URL_LOCAL
export const INVOICE_PAYMENT_URL = process.env.REACT_APP_BASE_INVOICE_PAYMENT_URL  